import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const PdfFeature = ({ refs }) => {
    const paste = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.pdfDownload.description.1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.pdfDownload.description.2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.pdfDownload.description.3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.saveIndividualBoards}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'page.home.feature.pdfDownload.tag'}
                id={'section-pdfDownload'}
                img={`/static/asset/img/features/download_pdf.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-pdfDownload-section'}
                title={'page.home.feature.pdfDownload.description'}
                explanations={paste}
            />
        </>
    );
};

export default PdfFeature;
